import { render, staticRenderFns } from "./PanelBase.vue?vue&type=template&id=ab6c3bfe&scoped=true&"
import script from "./PanelBase.vue?vue&type=script&lang=js&"
export * from "./PanelBase.vue?vue&type=script&lang=js&"
import style0 from "./PanelBase.vue?vue&type=style&index=0&id=ab6c3bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6c3bfe",
  null
  
)

export default component.exports